/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Receipt_TitleInputs */

const en_consumer_declaration_receipt_title = /** @type {(inputs: Consumer_Declaration_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema consumer declaration receipt`)
};

const de_consumer_declaration_receipt_title = /** @type {(inputs: Consumer_Declaration_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema-Eingangsbestätigung für Verbrauchererklärungen`)
};

const fr_consumer_declaration_receipt_title = /** @type {(inputs: Consumer_Declaration_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reçu de déclaration de consommateur Alchema`)
};

const es_consumer_declaration_receipt_title = /** @type {(inputs: Consumer_Declaration_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justificante de declaración del consumidor de Alchema`)
};

const it_consumer_declaration_receipt_title = /** @type {(inputs: Consumer_Declaration_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevuta della dichiarazione del consumatore Alchema`)
};

const nl_consumer_declaration_receipt_title = /** @type {(inputs: Consumer_Declaration_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema-ontvangstbewijs consumentenverklaring`)
};

const pl_consumer_declaration_receipt_title = /** @type {(inputs: Consumer_Declaration_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdzenie oświadczenia konsumenta Alchema`)
};

const fi_consumer_declaration_receipt_title = /** @type {(inputs: Consumer_Declaration_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcheman kuluttajailmoituksen kuitti`)
};

const da_consumer_declaration_receipt_title = /** @type {(inputs: Consumer_Declaration_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema-kvittering for forbrugererklæring`)
};

const sv_consumer_declaration_receipt_title = /** @type {(inputs: Consumer_Declaration_Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema-kvitto för konsumentförklaring`)
};

/**
* | output |
* | --- |
* | "Alchema consumer declaration receipt" |
*
* @param {Consumer_Declaration_Receipt_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_receipt_title = /** @type {((inputs?: Consumer_Declaration_Receipt_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Receipt_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_receipt_title(inputs)
	if (locale === "fr") return fr_consumer_declaration_receipt_title(inputs)
	if (locale === "es") return es_consumer_declaration_receipt_title(inputs)
	if (locale === "it") return it_consumer_declaration_receipt_title(inputs)
	if (locale === "nl") return nl_consumer_declaration_receipt_title(inputs)
	if (locale === "pl") return pl_consumer_declaration_receipt_title(inputs)
	if (locale === "fi") return fi_consumer_declaration_receipt_title(inputs)
	if (locale === "da") return da_consumer_declaration_receipt_title(inputs)
	if (locale === "sv") return sv_consumer_declaration_receipt_title(inputs)
	return en_consumer_declaration_receipt_title(inputs)
});